// extracted by mini-css-extract-plugin
export default {"body":"EditTagCtaDialog-module__body--c9736","footer":"EditTagCtaDialog-module__footer--a62b9"};